'use client'

import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import throttle from 'lodash.throttle'

import { LogoElementProps, LogoProps, LogoSvgProps } from '@/logo/Logo.schema'

import Link from '@/link/Link'

const LogoSvg = (props: LogoSvgProps): JSX.Element => {
    return (
        <svg className="logo__svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 48" focusable="false">
            <path fill={props.backgroundColor} d="M126.45 5.826a5.532 5.532 0 0 0-1.349-1.096l-4.237-3.227c-1.012-.895-2.349-1.41-3.89-1.41h-.047c-2.384 0-4.274 1.227-5.237 3.2l-.82-.616a3.886 3.886 0 0 0-.267-.18C108.169.846 105.157 0 102.162 0c-4.095 0-8.23 1.584-10.881 4.663l-4.702-3.52c-.614-.492-1.399-.77-2.283-.77h-6.432c-1.285 0-2.36.592-3 1.563l-1.059-.79-.067-.05h-.003a3.327 3.327 0 0 0-.244-.169 3.696 3.696 0 0 0-1.966-.555H65.14c-1.567 0-2.827.875-3.356 2.241l-2.061-1.537c-.056-.041-.11-.076-.166-.114-.044-.029-.09-.055-.134-.081-.052-.03-.102-.061-.154-.087a3.652 3.652 0 0 0-1.721-.422H28.665c-1.57 0-2.876.954-3.388 2.326l-2.041-1.509a3.748 3.748 0 0 0-2.347-.817H3.62C1.59.372 0 1.962 0 3.992v36.09c0 1.299.651 2.412 1.652 3.052l4.89 3.628.064.043c.038.026.079.056.117.079a3.647 3.647 0 0 0 1.969.573l17.22.014c1.558 0 2.858-.942 3.375-2.3l1.902 1.42a3.746 3.746 0 0 0 2.448.886l37.542.032c1.198 0 2.213-.515 2.864-1.367l.861.649c.143.107.294.2.448.282a3.63 3.63 0 0 0 1.748.441l5.373.006c1.16 0 2.178-.523 2.84-1.372l.684.515c.26.227.556.41.878.55a3.785 3.785 0 0 0 1.518.314l6.342.005c1.058 0 2.056-.46 2.733-1.262.288-.337.5-.724.643-1.136.017.014.038.026.055.038 2.425 1.81 5.583 2.828 8.924 2.828h.012c3.309 0 6.615-1.047 9.069-2.87 3.106-2.307 4.818-5.79 4.821-9.804 0-2.826-.006-5.756-.014-8.788-.006-2.288-.012-4.634-.015-7.026a6.3 6.3 0 0 0 1.056.093h.049c3.489 0 5.929-2.628 5.932-6.39v-2.87c.003-2.287-.846-3.72-1.561-4.522l.011.003Z" />
            <path fill={props.textColor} fillRule="evenodd" d="M102.156 3.155c4.859 0 10.552 2.823 10.552 9.532 0 3.473.013 6.821.025 10.052.011 3.012.022 5.921.022 8.733 0 6.71-5.877 9.532-10.739 9.532-4.862 0-10.599-2.823-10.552-9.532l.093-18.785c.047-6.71 5.74-9.532 10.599-9.532Zm-3.472 25.773c-.046 3.794 1.297 5.137 3.379 5.137s3.472-1.343 3.472-5.137c0-1.847-.011-4.145-.023-6.503v-.001c-.012-2.483-.024-5.032-.024-7.19 0-3.794-1.297-5.137-3.332-5.137-2.036 0-3.332 1.343-3.379 5.136l-.093 13.695ZM9.91 3.528H3.615c-.276 0-.462.182-.462.461v36.09c0 .277.183.463.462.463H9.91c.277 0 .463-.183.463-.462V3.99c0-.277-.184-.463-.463-.463Zm10.975 0H14.54c-.276 0-.462.182-.462.461v36.09c0 .277.186.463.462.463h6.296c.276 0 .462-.183.462-.462V23.609c0-.277.137-.463.37-.463.232 0 .415.093.508.37l5.833 16.657c.093.276.323.369.555.369h6.389c.276 0 .462-.183.462-.462V3.99c0-.277-.183-.463-.462-.463h-6.296c-.276 0-.462.183-.462.462v16.657c0 .276-.137.463-.37.463a.598.598 0 0 1-.555-.37L21.44 3.896a.602.602 0 0 0-.555-.369Zm27.532 30.121H56.7c.276 0 .462.186.462.462v5.969c0 .279-.186.462-.462.462H38.14c-.323 0-.463-.186-.37-.509l9.811-29.105c.093-.322-.046-.508-.369-.508h-8.238c-.279 0-.462-.186-.462-.463V3.99c0-.279.186-.462.462-.462h18.56c.323 0 .463.186.37.509L48.047 33.14c-.093.322.047.508.37.508ZM64.66 3.943l-5.32 36.09c-.047.276.136.509.415.509h6.342c.276 0 .416-.093.462-.416L68.55 26.8c.047-.322.186-.415.462-.415.277 0 .416.136.463.415l2.082 13.326c.046.276.183.416.462.416h5.368c.276 0 .416-.137.462-.416L79.93 26.8c.047-.276.186-.415.462-.415.277 0 .416.093.463.415l1.989 13.326c.046.323.183.416.462.416h6.342c.276 0 .462-.23.416-.509l-5.322-36.09c-.046-.323-.183-.416-.462-.416h-6.432c-.276 0-.416.093-.462.416l-2.408 22.442c-.046.322-.186.415-.462.415s-.416-.14-.463-.462L72.018 3.99c-.046-.322-.23-.462-.509-.462h-6.385c-.276 0-.416.093-.463.416Zm52.317-.697h-.046c-1.666 0-2.777 1.11-2.777 3.238v2.87c0 2.127 1.111 3.238 2.777 3.238h.046c1.667 0 2.777-1.11 2.777-3.239V6.484c0-2.128-1.11-3.238-2.777-3.238Zm.047 8.375h-.047c-1.154 0-1.942-.785-1.942-2.683V6.903c0-1.895.785-2.683 1.942-2.683h.047c1.157 0 1.852.785 1.852 2.683v2.035c0 1.895-.695 2.683-1.852 2.683Zm-1.204-5.878c-.046 0-.093.047-.093.093v4.123c0 .046.047.092.093.092h.788a.1.1 0 0 0 .093-.093V8.522c0-.046.047-.046.047-.046.093 0 .369 0 .416.276l.186 1.203c0 .093.046.093.093.093h.831c.047 0 .093 0 .093-.093l-.232-1.343c-.047-.369-.23-.509-.416-.602.23-.093.509-.322.509-.97 0-.928-.509-1.297-1.204-1.297h-1.204Zm1.064 1.945h-.093c-.046 0-.093-.047-.093-.093V6.577c0-.046.047-.093.093-.093h.093c.323 0 .416.28.416.556 0 .232-.046.648-.416.648Z" clipRule="evenodd" />
        </svg>
    )
}

const LogoElement = (props: LogoElementProps) => {
    const className = classNames('logo__content', {
        'logo__content--button': props.onClick
    })

    if (props.onClick) {
        return (
            <button onClick={props.onClick} className={className}>
                {props.children}
            </button>
        )
    }

    if (props.url) {
        return (
            <Link href={props.url} className={className}>
                {props.children}
            </Link>
        )
    }

    return (
        <div className={className}>
            {props.children}
        </div>
    )
}

const Logo = (props: LogoProps): JSX.Element => {
    const [isLogoHidden, setIsLogoHidden] = useState(true)
    const className: string = classNames('logo', props.className, {
        'is-logo-hidden': props.hasScrollFade && (isLogoHidden !== props.scrollFadeIn)
    })

    const backgroundColor = props.isInverted ? '#000' : '#fff'
    const textColor = props.isInverted ? '#fff' : '#000'

    useEffect(() => {
        const handleScroll = throttle(() => {
            setIsLogoHidden(window.scrollY < 160)
        }, 100)

        document.addEventListener('scroll', handleScroll)
        handleScroll()
    }, [])

    return (
        <div className={className}>
            <LogoElement onClick={props.onClick as () => void} url={props.url}>
                <LogoSvg backgroundColor={backgroundColor} textColor={textColor} />
            </LogoElement>
        </div>
    )
}

export default Logo
